import axios from 'axios'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const BRAND_CREATE_URL = `${API_URL}api/v1/definition/brand/create`
export const BRAND_GET_ALL_URL = `${API_URL}api/v1/definition/brand/all`
export const BRAND_DELETE_URL = `${API_URL}api/v1/definition/brand/delete`
export const BRAND_UPDATE_URL = `${API_URL}api/v1/definition/brand/update`

export function createBrand(name: string) {
  return axios.post(BRAND_CREATE_URL, { name })
}

export function loadBrands(page = 0) {
  return axios.get(BRAND_GET_ALL_URL, { params: { page, size: 10 } })
}

export function deleteBrand(brandId: string) {
  return axios.post(BRAND_DELETE_URL + brandId)
}
export function updateBrand(brandId: string | null, name: string) {
  return axios.post(BRAND_UPDATE_URL + brandId, { name })
} 

